import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useCart } from '@sola/cart-sdk/store.tsx';
import { trackError } from '@sola/tracking/components/datalayer.tsx';
import { useDonate } from '../donate-context.tsx';
let cartFetched = false;
let listenersAdded = false;
export const useDonateValidation = () => {
  const $ = _c(16);
  const {
    state
  } = useDonate();
  const {
    actions: t0
  } = useCart("actions", "cart");
  const {
    getCart
  } = t0;
  let t1;
  if ($[0] !== state.donateFrequency || $[1] !== state.otherAmounts || $[2] !== state.selectedAmounts) {
    t1 = () => {
      if (state.selectedAmounts[state.donateFrequency] === "other") {
        return state.otherAmounts[state.donateFrequency];
      }
      return state.selectedAmounts[state.donateFrequency];
    };
    $[0] = state.donateFrequency;
    $[1] = state.otherAmounts;
    $[2] = state.selectedAmounts;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const getCurrentAmount = t1;
  let t2;
  if ($[4] !== getCurrentAmount || $[5] !== state.submitError) {
    t2 = () => {
      const amount = getCurrentAmount();
      if (!amount) {
        return {
          isValid: false,
          isDisabled: false,
          message: undefined
        };
      }
      if (state.submitError) {
        trackError(state.submitError.toString());
        return {
          isValid: false,
          isDisabled: false,
          message: state.submitError
        };
      }
      return {
        isValid: true,
        isDisabled: false,
        message: undefined
      };
    };
    $[4] = getCurrentAmount;
    $[5] = state.submitError;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const getValidationState = t2;
  let t3;
  let t4;
  if ($[7] !== getCart) {
    t3 = () => {
      const refreshCart = () => {
        if (getCart) {
          getCart();
          cartFetched = true;
        }
      };
      const handleFocus = () => {
        refreshCart();
      };
      const handleBeforeUnload = _temp;
      if (!cartFetched && getCart !== undefined) {
        refreshCart();
      }
      if (!listenersAdded && getCart !== undefined) {
        window.addEventListener("beforeunload", handleBeforeUnload);
        window.addEventListener("focus", handleFocus);
        listenersAdded = true;
      }
    };
    t4 = [getCart];
    $[7] = getCart;
    $[8] = t3;
    $[9] = t4;
  } else {
    t3 = $[8];
    t4 = $[9];
  }
  useEffect(t3, t4);
  let t5;
  if ($[10] !== getValidationState) {
    t5 = getValidationState();
    $[10] = getValidationState;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const validationState = t5;
  let t6;
  if ($[12] !== getCurrentAmount || $[13] !== getValidationState || $[14] !== validationState) {
    t6 = {
      getCurrentAmount,
      getValidationState,
      validationState
    };
    $[12] = getCurrentAmount;
    $[13] = getValidationState;
    $[14] = validationState;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};
function _temp() {
  cartFetched = false;
}